import {AlertTitle, Box, Card, CardActions, CardContent, CardHeader, Typography} from "@mui/material";
import {api_host} from "../../../fetch.js"
import {useAuth} from "../../Auth/AuthPage.jsx";
import {useEffect, useState} from "react";
import Alert from "@mui/material/Alert";
import {copyToClipboard} from "../../Event.jsx";
import Button from "@mui/material/Button";
import {validate} from "uuid";
import {Crumbs} from "../../Crumbs.jsx";
import LoginRequired from "../../LoginRequired.jsx";

const calendarURL = (api_host, privateToken) => `${api_host}/?action=iCalFeed&token=${privateToken}`
const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];


export const CalendarIntegrationPage = (props) => {
    const { user} = useAuth();
    const [token, setToken] = useState(null);

    useEffect(() => {
        // Fetch user private settings from Strapi
        const fetchPrivateSettings = async () => {
            const res = await fetch(`${BACKEND_HOST}/user-private/me`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                }
            });
            if (res.ok) {
                const data = await res.json();
                // Assume token is in data.calendarToken
                if (validate(data.calendarToken)) {
                    setToken(data.calendarToken);
                } else {
                    setToken(false);
                }
            } else {
                setToken(false);
            }
        };
        fetchPrivateSettings();
    }, []);

    const iCalURL = calendarURL(api_host, token);
    return (
        <Box>
            <Crumbs crumbs={[
                {title: "Account", href: "/account"},
                {title: "Calendar Integration"}
            ]} />
            <LoginRequired>
                <Card>
                    <CardHeader title={"Calendar Integration"} />
                    <CardContent>
                        <Typography variant={"body2"}>Wanna see all of your starred events on your favorite calendar app? Paste the link below into your app's calendar settings.</Typography>
                        <Alert severity={"warning"} icon={false}>
                            <AlertTitle>Privacy Warning</AlertTitle>
                            <Typography variant={"body2"}><em>Anyone with this link can see all of the events you have added a star to. Do not share.</em></Typography>
                        </Alert>
                        {validate(token) && <pre>{iCalURL}</pre>}
                        {token === null && <pre>Generating Link</pre>}
                        {token === false && <pre>Unable to generate Link</pre>}
                        <CardActions>
                            <Button variant={"contained"} disabled={!validate(token)} onClick={(e) => copyToClipboard(e, iCalURL, user)}>Copy Link</Button>
                        </CardActions>
                        <Alert severity={"info"} icon={false}>
                            <AlertTitle>Pro Tip</AlertTitle>
                            <Typography variant={"body2"}><em>It's important to paste the link directly into your calendar app, if you open this link and add the resulting downloaded (.ics) calender file, your calendar will not receive updates.</em></Typography>
                        </Alert>
                    </CardContent>
                </Card>
            </LoginRequired>
        </Box>
    );
}